const setNewsFeedId = (state, newsFeedId) => {
  state.newsFeedId = newsFeedId;
};

export { setNewsFeedId };
